import { useMutation } from 'react-query';
import axios from 'axios';
import { TerminalAppearanceAPI } from '../../../constants/API';
import { queryClient } from '../../../queryClient';
import { commonHeaders } from '../../../constants/HeadersAPI';
import { useContext } from 'react';
import { AlertContext } from '../../../context/AlertProvider';
import { AlertType } from '../../../types/enums';
import { defaultSuccessMessage } from '../../../constants/alertText';

export const useDeleteTerminalBackground = () => {
  const context = useContext(AlertContext);

  const { mutate: deleteTerminalBackground, isLoading: isDeleteTerminalBackgroundLoading } =
    useMutation(
      ['TerminalAppearanceDeleteBackground'],
      (backgroundId: number) =>
        axios.delete(TerminalAppearanceAPI.deleteBackground(backgroundId), commonHeaders()),
      {
        onSuccess: () => {
          queryClient
            .invalidateQueries('TerminalAppearance')
            .then(() =>
              context?.setAlert({ type: AlertType.Success, message: defaultSuccessMessage })
            );
        }
      }
    );

  return { deleteTerminalBackground, isDeleteTerminalBackgroundLoading };
};
